import React from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash/fp';

import styles from './emptySlots.module.css';

const createDash = i => (
  <div className={styles.dash} key={i}>
    <hr />
  </div>
);

const EmptySlots = ({
  hasAvailableSlots,
  currentFilter,
  maxLength,
  showAll,
}) => (
  <div className={styles.container}>
    {hasAvailableSlots ? (
      <div className={styles.inner}>
        <div
          className={styles.text}
        >{`No ${currentFilter} appointments available`}</div>
      </div>
    ) : (
      <div className={styles.dashContainer}>
        {times(i => createDash(i))(showAll ? maxLength + 1 : 4)}
      </div>
    )}
  </div>
);

EmptySlots.propTypes = {
  currentFilter: PropTypes.string.isRequired,
  hasAvailableSlots: PropTypes.bool.isRequired,
  maxLength: PropTypes.number.isRequired,
  showAll: PropTypes.bool.isRequired,
};

export default EmptySlots;
